import { render, staticRenderFns } from "./MaterialsModal.vue?vue&type=template&id=2fd516de&"
import script from "./MaterialsModal.vue?vue&type=script&lang=ts&"
export * from "./MaterialsModal.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialsModal.vue?vue&type=style&index=0&id=2fd516de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports